"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultArtistImageUrls = void 0;
var DefaultArtistImageUrls;
(function (DefaultArtistImageUrls) {
    DefaultArtistImageUrls["Individual"] = "https://storage.googleapis.com/sellout-assets/default-images/performer/individual.jpg";
    DefaultArtistImageUrls["MusicalArtist"] = "https://storage.googleapis.com/sellout-assets/default-images/performer/musical-artist.jpg";
    DefaultArtistImageUrls["Film"] = "https://storage.googleapis.com/sellout-assets/default-images/performer/film.jpg";
})(DefaultArtistImageUrls = exports.DefaultArtistImageUrls || (exports.DefaultArtistImageUrls = {}));
;
//# sourceMappingURL=DefaultArtistImageUrls.js.map